var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-title"},[_c('div',{staticClass:"title-main"},[_vm._v(_vm._s(_vm.title))]),(_vm.intro)?_c('div',{staticClass:"title-intro"},[_vm._v(_vm._s(_vm.intro))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }